export default __webpack_public_path__ + "static/media/brand-8.0f70a216.png";